import './es.number.constructor-f2ac18e9.js';
import { r as registerComponent } from './index-f674799c.js';
import { u as useToggler } from './useToggler-e9ff86c0.js';
import { t as toRefs, r as ref, c as computed } from './reactivity.esm-bundler-12dbef55.js';
import { resolveComponent, resolveDirective, openBlock, createElementBlock, normalizeClass, withDirectives, createElementVNode, createVNode, createCommentVNode, vShow, toDisplayString } from 'vue';
import './to-string-6d234645.js';
import './path-6fd8cb75.js';
import './object-set-prototype-of-1688b6af.js';
import './string-trim-244b288d.js';

var script = {
  name: 'form-control-file',
  props: {
    name: {
      required: true,
      type: String
    },
    label: {
      required: false,
      type: String,
      default: ''
    },
    required: {
      required: false,
      type: Boolean,
      default: false
    },
    error: {
      required: false,
      type: String,
      default: ''
    },
    serverError: {
      required: false,
      type: String,
      default: ''
    },
    help: {
      required: false,
      type: String,
      default: ''
    },
    accepts: {
      required: false,
      type: String,
      default: '' // example: accepts="image/*,.pdf,.doc,.odt,.docx"

    },
    fileSizeLimitByte: {
      required: false,
      type: Number,
      default: 0 // 0 means no limit

    },
    additionalLabelClasses: {
      required: false,
      type: String,
      default: ''
    },
    prefixId: {
      required: false,
      type: String,
      default: 'wdw-bms-attr'
    }
  },
  emits: ['validate'],
  setup: function setup(props, context) {
    var _toRefs = toRefs(props),
        name = _toRefs.name,
        label = _toRefs.label,
        required = _toRefs.required,
        serverError = _toRefs.serverError,
        additionalLabelClasses = _toRefs.additionalLabelClasses,
        prefixId = _toRefs.prefixId,
        fileSizeLimitByte = _toRefs.fileSizeLimitByte;

    var _useToggler = useToggler(),
        shouldShowHelp = _useToggler.toggleValue,
        toggleHelpText = _useToggler.toggle;

    var showError = ref(false);
    var value = ref(null); //+-------------------------+
    //|     Other methods       |
    //+-------------------------+

    function onFileChosen(event) {
      /**
       * Note: For some reason, vee-validate 4's validation using composition API doesn't trigger its validation method
       *  unlike other form controls. Since we don't want to mix with vee-validate's non-composition API, we use traditional
       *  method of change event
       *
       * The change event also emits "validate"-event to parent component.
       */
      var field = event.target;
      var uploadedFile = {
        validated: true,
        name: name.value,
        type: 'file',
        value: null,
        valueHuman: null
      };

      if (field !== null && field !== void 0 && field.files && field.files[0]) {
        var f = field.files[0]; //validation

        var validated = fileSizeLimitByte.value <= 0 || f.size < fileSizeLimitByte.value;
        showError.value = !validated;

        if (validated) {
          uploadedFile.value = f;
          uploadedFile.valueHuman = {
            name: f.name,
            type: f.type,
            size: f.size
          };
        } else {
          field.value = '';
        }

        context.emit('validate', uploadedFile);
      } else {
        uploadedFile.validated = !required.value;
        showError.value = !uploadedFile.validated;
        value.value = uploadedFile; // Emit event

        context.emit('validate', uploadedFile);
      }
    } //+-------------------------+
    //|     Computed            |
    //+-------------------------+


    var hasServerError = computed(function () {
      return serverError.value != undefined && serverError.value !== '';
    });
    var wrapperClassName = computed(function () {
      return {
        'form-group': true,
        'has-error': showError.value || hasServerError.value
      };
    });
    var labelClassName = computed(function () {
      return additionalLabelClasses.value + ' ' + (showError.value || hasServerError.value ? 'text-danger' : '');
    });
    var labelText = computed(function () {
      return label.value + (required.value ? '*' : '');
    });
    var idInput = computed(function () {
      return prefixId.value + '-file-' + name.value;
    });
    var idErrorText = computed(function () {
      return prefixId.value + '-file-' + name.value + '-error';
    });
    return {
      // Computed
      wrapperClassName: wrapperClassName,
      labelClassName: labelClassName,
      idInput: idInput,
      idErrorText: idErrorText,
      hasServerError: hasServerError,
      labelText: labelText,
      // Methods
      toggleHelpText: toggleHelpText,
      // Events
      onFileChosen: onFileChosen,
      // VARS
      shouldShowHelp: shouldShowHelp,
      showError: showError,
      value: value
    };
  }
};

var _hoisted_1 = ["for"];
var _hoisted_2 = {
  class: "alert alert-info alert-dismissible mb-2 form-info-message",
  role: "alert"
};
var _hoisted_3 = ["id", "data-vv-as", "name", "required", "aria-invalid", "aria-describedby", "accept"];
var _hoisted_4 = ["id"];
var _hoisted_5 = ["id"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  var _directive_dompurify_html = resolveDirective("dompurify-html");

  return openBlock(), createElementBlock("div", {
    class: normalizeClass($setup.wrapperClassName)
  }, [withDirectives(createElementVNode("label", {
    class: normalizeClass($setup.labelClassName),
    for: $setup.idInput
  }, null, 10, _hoisted_1), [[_directive_dompurify_html, $setup.labelText]]), $props.help ? (openBlock(), createElementBlock("span", {
    key: 0,
    class: "help-trigger",
    title: "Hilfe anzeigen",
    onClick: _cache[0] || (_cache[0] = function () {
      return $setup.toggleHelpText && $setup.toggleHelpText.apply($setup, arguments);
    })
  }, [createVNode(_component_font_awesome_icon, {
    icon: "question-circle",
    size: "lg"
  })])) : createCommentVNode("", true), withDirectives(createElementVNode("div", _hoisted_2, [withDirectives(createElementVNode("span", null, null, 512), [[_directive_dompurify_html, $props.help]]), createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "aria-label": "Close",
    onClick: _cache[1] || (_cache[1] = function () {
      return $setup.toggleHelpText && $setup.toggleHelpText.apply($setup, arguments);
    })
  })], 512), [[vShow, $setup.shouldShowHelp]]), createElementVNode("input", {
    id: $setup.idInput,
    "data-vv-as": $setup.labelText,
    name: $props.name,
    required: $props.required,
    "aria-invalid": $setup.showError || $setup.hasServerError,
    "aria-describedby": $setup.idErrorText,
    class: "form-control",
    type: "file",
    accept: $props.accepts,
    onChange: _cache[2] || (_cache[2] = function () {
      return $setup.onFileChosen && $setup.onFileChosen.apply($setup, arguments);
    }),
    tabindex: "0"
  }, null, 40, _hoisted_3), withDirectives(createElementVNode("span", {
    id: $setup.idErrorText,
    "aria-atomic": "true",
    class: "text-danger form-error-message"
  }, toDisplayString($props.error || $props.help), 9, _hoisted_4), [[vShow, $setup.showError]]), withDirectives(createElementVNode("span", {
    id: $setup.idErrorText,
    "aria-atomic": "true",
    class: "text-danger form-error-message"
  }, toDisplayString($props.serverError), 9, _hoisted_5), [[vShow, $setup.hasServerError]])], 2);
}

script.render = render;
script.__scopeId = "data-v-a836489c";

var Plugin = {
  install: function install(vue) {
    registerComponent(vue, script);
  }
}; // use(Plugin);

export { script as File, Plugin as default };
